export const BUSINESS_ENTITY_TAX_CLASSIFICATION = Object.freeze({
  S_CORPORATION: 's_corporation',
  C_CORPORATION: 'c_corporation',
  PARTNERSHIP: 'partnership',
  SINGLE_MEMBER_LLC: 'single_member_llc'
});

export const BUSINESS_FINANCE_TAX_ACCOUNT_PARTNERS = Object.freeze({
  APRIL: 'april',
  ONE_800_ACCOUNTANT: '1800accountant'
});

export const TAX_ENTITLEMENTS = Object.freeze({
  // 1800A Entitlements
  TAX_UNLIMITED_ADVICE: 'tax_unlimited_advice',
  TAX_ANNUAL_FILING: 'tax_annual_filing',
  TAX_ANNUAL_FILING_PRIOR_YEAR: 'tax_annual_filing_prior_year',
  // April Entitlements
  ZB_QUARTERLY_TAX_PLANNING: 'zb_quarterly_tax_planning',
  ZB_TAX_FULL_SERVICE_BIZ_PER_LLC: 'zb_tax_full_service_biz_per_llc',
  ZB_TAX_FULL_SERVICE_BIZ_PARTNERSHIP: 'zb_tax_full_service_biz_partnership',
  ZB_TAX_FULL_SERVICE_BIZ_S_CORP: 'zb_tax_full_service_biz_s_corp',
  ZB_TAX_FULL_SERVICE_BIZ_C_CORP: 'zb_tax_full_service_biz_c_corp'
});

// Map of business entity tax classification to entitlement service code
// NOTE: These tax entitlements are the same as service codes, thus we use tax entitlements constants as service codes.
export const TAX_CLASSIFICATION_TO_SERVICE_MAP = Object.freeze({
  [BUSINESS_ENTITY_TAX_CLASSIFICATION.SINGLE_MEMBER_LLC]:
    TAX_ENTITLEMENTS.ZB_TAX_FULL_SERVICE_BIZ_PER_LLC,
  [BUSINESS_ENTITY_TAX_CLASSIFICATION.PARTNERSHIP]:
    TAX_ENTITLEMENTS.ZB_TAX_FULL_SERVICE_BIZ_PARTNERSHIP,
  [BUSINESS_ENTITY_TAX_CLASSIFICATION.S_CORPORATION]:
    TAX_ENTITLEMENTS.ZB_TAX_FULL_SERVICE_BIZ_S_CORP,
  [BUSINESS_ENTITY_TAX_CLASSIFICATION.C_CORPORATION]:
    TAX_ENTITLEMENTS.ZB_TAX_FULL_SERVICE_BIZ_C_CORP
});
